(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/middleware-payment-done/assets/payment-done.js') >= 0) return;  svs.modules.push('/components/payment/middleware-payment-done/assets/payment-done.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$components$payme = svs.components.payment.middleware.paymentDone.messages,
  getErrorMessage = _svs$components$payme.getErrorMessage,
  getPaymentMessage = _svs$components$payme.getPaymentMessage,
  successfulMessagesFractions = _svs$components$payme.successfulMessagesFractions;
const fractionTitle = successfulMessagesFractions.fractionTitle,
  fractionMessage = successfulMessagesFractions.fractionMessage;
const showExternalErrorMessage = svs.components.payment.common.error.ExternalErrorMessage.showExternalErrorMessage;
const PayableType = svs.components.payment.common.constants.PayableType;
const analytics = svs.components.analytics;
const groupTypes = svs.components.marketplaceData.constants.groupTypes;
const getDisplayName = svs.utils.products.getDisplayName;
const trackEvent = _ref => {
  let trackingAction = _ref.trackingAction,
    paidProductIds = _ref.paidProductIds;
  const trackingProductName = Array.isArray(paidProductIds) ? getDisplayName(paidProductIds[0]) : getDisplayName(paidProductIds);
  analytics.trackEvent({
    category: 'overlays',
    action: trackingAction,
    opt_label: trackingProductName
  });
};
const paymentDone = (onInteractionSuccess, onInteractionFailure) => _ref2 => {
  let payment = _ref2.payment,
    paymentInfo = _ref2.paymentInfo,
    userContext = _ref2.userContext;
  return async next => {
    try {
      const _payment$paymentRespo = payment.paymentResponse,
        result = _payment$paymentRespo.result,
        error = _payment$paymentRespo.error;
      const paidItems = result.getPaidPayableItems();
      const payableType = payment.getPayableType();
      let interactionProps;
      let dialogTitle;
      let dialogMessage = '';
      if (paidItems.length > 0) {
        switch (payableType) {
          case PayableType.FRACTION:
            interactionProps = {
              title: fractionTitle(result),
              message: fractionMessage(payment, result),
              onCallback: action => {
                if (userContext.callback) {
                  userContext.callback();
                }
                analytics.trackEvent({
                  category: 'overlays',
                  action,
                  opt_label: 'Fraction'
                });
              }
            };
            break;
          case PayableType.WAGER:
            {
              const paidProductIds = [...new Set(paidItems.reduce((products, wager) => products.concat(wager.getProductBet.productId), []))];
              const mybetsUrl = svs.components.payment.middleware.paymentDone.utils.getMybetsUrl(paidProductIds);
              const marketplaceWager = paidItems.find(wager => wager.getIsMarketplaceWager());
              var _await$getPaymentMess = await getPaymentMessage(paidItems, result.getUnpaidPayableItems(), result.getPaidPayableItemsDTO(), paymentInfo);
              var _await$getPaymentMess2 = _slicedToArray(_await$getPaymentMess, 2);
              dialogTitle = _await$getPaymentMess2[0];
              dialogMessage = _await$getPaymentMess2[1];
              interactionProps = {
                title: dialogTitle,
                message: dialogMessage,
                mybetsUrl,
                isRetailer: marketplaceWager && marketplaceWager.role === groupTypes.RETAILER,
                onCallback: action => {
                  if (userContext.callback) {
                    userContext.callback();
                  }
                  trackEvent({
                    trackingAction: action,
                    paidProductIds
                  });
                }
              };
              break;
            }
          default:
        }
        await onInteractionSuccess(interactionProps);
      } else if (error) {
        const errorObjects = error.toJSON();
        if (svs.core.detect.feature('ft-caretech-uc2-dialog')) {
          if (!(await showExternalErrorMessage(errorObjects))) {
            var _errorObjects$0$clien, _errorObjects$;
            const clientErrors = getErrorMessage(result.getUnpaidPayableItems(), error, paymentInfo);
            const clientCode = (_errorObjects$0$clien = (_errorObjects$ = errorObjects[0]) === null || _errorObjects$ === void 0 ? void 0 : _errorObjects$.clientCode) !== null && _errorObjects$0$clien !== void 0 ? _errorObjects$0$clien : undefined;
            onInteractionFailure({
              clientErrors,
              clientCode
            });
          }
        } else {
          var _errorObjects$0$clien2, _errorObjects$2;
          const clientErrors = getErrorMessage(result.getUnpaidPayableItems(), error, paymentInfo);
          const clientCode = (_errorObjects$0$clien2 = (_errorObjects$2 = errorObjects[0]) === null || _errorObjects$2 === void 0 ? void 0 : _errorObjects$2.clientCode) !== null && _errorObjects$0$clien2 !== void 0 ? _errorObjects$0$clien2 : undefined;
          onInteractionFailure({
            clientErrors,
            clientCode
          });
        }
      }
    } catch (error) {
      onInteractionFailure({
        clientErrors: getErrorMessage()
      });
    }
    next();
  };
};
setGlobal('svs.components.payment.middleware.paymentDone.paymentDone', paymentDone);

 })(window);